import Vue from 'vue'
import axios from 'axios'


Vue.use({
    install(Vue) {
        // Vue.prototype.$http = axios
        Vue.prototype.$http = axios.create({
            baseURL: '/api/v1',
        })

        axios.interceptors.request.use(function (config) {
            const token = localStorage.getItem('must_token');
            const visitor = document.querySelector("meta[name=visitor]").getAttribute("content");

            if (!token) {
                localStorage.setItem('visitor_token', visitor);
            }
            
            config.headers.Authorization =  token;
            config.headers['visitor'] =  visitor;
          
            return config;
        });
    }
})